import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const saveUserPageContactInfoApi = (getState, val) => {
  if (val.nextBillDate) {delete val.nextBillDate;}
  
  return fetchWithState(getState, {
    method: 'POST',
    url: '/tl/updateUserOfAccount',
    body: val,
  }).then(getFetchedJSON);
};

export const getUserAccountInfoApi = (getState) => fetchWithState(getState, {
  method: 'POST',
  url: '/tl/getUserOfAccount',
}).then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/userAccountPage/api.js